import { startSteps } from '@/mocks/haijiao';

export default function HowTo() {
  return (
    <section id="howto" className="py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div>
          <p className="text-sm font-semibold tracking-widest text-primary-600">海角吃瓜怎么玩</p>
          <h2 className="mt-3 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
            三步走完
            <br />
            你的<em className="not-italic text-primary-600">吃瓜入门</em>
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-foreground-600">
            不用背复杂规则，也不需要在各种入口里迷路。跟着这三步，先把「围观」这件事做得清爽而有分寸，
            再慢慢精进海角吃瓜技巧也不迟。
          </p>
          <a
            href="#rules"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-accent-600 transition-colors hover:text-accent-700"
          >
            先读懂吃瓜规则
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <ol className="relative space-y-4">
          {startSteps.map((s, i) => (
            <li
              key={s.no}
              className="relative flex gap-5 rounded-2xl bg-background-100/70 p-6 transition-colors hover:bg-background-100 md:p-7"
            >
              <span className="font-heading text-3xl font-bold text-accent-500/80 md:text-4xl">
                {s.no}
              </span>
              <div className={i < startSteps.length - 1 ? 'pb-2' : ''}>
                <h3 className="text-lg font-semibold text-foreground-950">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}